<template>
  <v-snackbar v-model="showNotify"
              bottom right
              :color="color"
              multi-line
              @input="closeNotify"
              :timeout=5000>
    {{ text }}
    <v-btn icon dark @click="closeNotify">
      <fa-icon icon="times" size="lg"/>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Notify',
  data: () => ({
    showNotify: false,
    isError: false
  }),
  watch: {
    notify(val) {
      if (val) {
        this.showNotify = true
      }
    }
  },
  computed: {
    notify () {
      const notify = this.$store.state.general.notify
      const error = this.$store.state.general.error
      this.setErrorNotify(error)
      return notify || error
    },
    color () {
      if (this.isError) {
        return 'error'
      }
      return this.notify && this.notify.color
        ? this.notify.color
        : 'secondary'
    },
    text () {
      return this.notify && this.notify.text
        ? this.notify.text
        : undefined
    }
  },
  methods: {
    closeNotify () {
      this.showNotify = false
      this.$store.commit('SET_NOTIFY', null)
      this.$store.commit('SET_ERROR', null)
    },
    inputNotify () {
      // console.log(event)
    },
    setErrorNotify(error) {
      this.isError = error ? true : false
    }
  }
}
</script>
